import { css, keyframes } from '@emotion/core'
import { ShowAni, HideAni, mq, mqMin, TxtLimit } from '@styles/base.style'
import styled, { Theme } from '@themes/theme'

// 상세 베팅 슬립 스타일
export const BetSiderStyle = css`
  text-align: center;
  border-bottom: none !important;
  z-index: 99;
`
export const betslipPlusAni = keyframes`
  0% {
    opacity: 1;
    top: 2px;
    transform: scale(1);
  }
  30% {
    opacity: 1;
  }
  40% {
    transform: scale(1.25);
  }
  100% {
    opacity: 0;
    top: -10px;
    transform: scale(1.1);
  }
  `
export const componentBetslipScaleAni = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.4);
  }
  `
// /////////////////////////////////////////// BetSlipBottom /////////////////////////////////////////////

const HeightAni = keyframes`
  0% {
    height:182px;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    height: 0.1px;
  }
`
export const AniPointColor = 'rgba(238,238,238,.9)'
export const AniPointColorHide = 'rgba(238,238,238,0)'
const AniPointTxtColor = '#2ecadb'
const bgBigAni = keyframes`
  0% {
    width: 25px;
    height: 150px;
    transform: rotate(40deg) translate(-100%, -70%);
    background: ${AniPointColor};
  }
  40% {
    width: 25px;
  }
  70% {
    background: ${AniPointColor};
  }
  100% {
    width: 5px;
    height: 150px;
    transform: rotate(40deg) translate(23vw, -31vw);
    background: ${AniPointColorHide};
  }
`
const PCbgBigAni = keyframes`
  0% {
    width: 15px;
    height: 150px;
    transform: rotate(40deg) translate(-120%, -70%);
    background: ${AniPointColor};
  }
  40% {
    width: 15px;
  }

  100% {
    width: 5px;
    height: 150px;
    transform: rotate(40deg) translate(400px, -10px);
    background: ${AniPointColorHide};
  }
`
const bgSmallAni = keyframes`
  0% {
    width: 15px;
    height: 150px;
    transform: rotate(40deg) translate(-80%, -70%);
    background: ${AniPointColor};
  }
  40% {
    width: 15px;
  }
  90% {
    background: ${AniPointColor};
  }
  100% {
    width: 10px;
    height: 150px;
    transform: rotate(40deg) translate(16vw, -31vw);
    background: ${AniPointColorHide};
  }
`
const peekAni = keyframes`
    25% {
      transform: rotateX(50deg) translateY(2px) rotate(-8deg) scale(1);
    }
    30%, 55% {
      //color: ${AniPointTxtColor};
    }
    45% {
      transform: translateY(-4px) rotate(2deg) scale(1.4);
    }
`
const bgColorAni = keyframes`
    20%, 40% {
      background: rgba(183,183,183,0.8);
    }
    0%, 100% {
      background: #d5d5d5;
    }
`
export const CommonPeekAni = css`
  position: relative;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  animation: ${bgColorAni} ease-out 1;
  .betslip-ani--bg  {
    position: absolute;
    top: 50%;
    left: -40px;
    &.big {
      ${mq[2]} {
        animation: ${bgBigAni} ease-out 1;
      }
    }
    &.small {
      ${mq[2]} {
        animation: ${bgSmallAni} ease-out 1;
      }
    }
    &.pc {
      ${mqMin[4]} {
        animation: ${PCbgBigAni} ease-out 1;
      }
    }
  }
  .ani-num {
    animation: ${peekAni} cubic-bezier(.28,.65,.69,.57) 1;
    transform-origin: bottom;
  }

`
export const BetSlipBottomModal = styled.div`
  //z-index: 99;
  //position: fixed;
  //left:0;
  //bottom:0;
  //width: 100%;
`
// 베팅슬립 공통 Gmoney 스타일
const GmoneyIcoStyle = css`
  position: relative;
  display: inline-block;
  width: 10px;
  margin-left: 4px;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: inherit;
  }
`

const lineAni = keyframes`
  20%, 40% {
    border: 1px solid rgba(170, 255, 0, .9);
    box-shadow: 0 0 6px rgba(170, 255, 0, .3);
  }
  0%, 100% {
    border: 1px solid transparent;
    box-shadow: none;
  }
`
export const BetSlipBottomWrapper = styled.div`
  //animation: ${lineAni} .8s infinite;
  border-radius: 50%;

  &.change-odds, &.change-even {
    animation: ${lineAni} cubic-bezier(.16,.57,.63,.62) 1;
  }
  &.pc {
    position: relative;
  }
  // 중앙 화살표 버튼
  .arrow-btn {
    display: block;
    width: 58px;
    height: 18px;
    text-align: center;
    margin: 0 auto;
    background-color: ${props => props.theme.color.btn};
    border-radius: 0 0 50px 50px;
    svg {
      position: relative;
      width: 10px;
      height: auto;
    }
    &.collapse svg {
      transition: all 0.3s;
      transform: rotate(180deg) translateY(20%);
    }
    &.expand svg {
      transform: rotate(0) translateY(-20%);
    }
  }
  .hide-simple {
    display: none;
    height: 0.1px;
    overflow: hidden;
    animation: ${HideAni} 0.3s;
  }
  .hide-detail {
    display: none;
    padding: 0 20px;
    overflow: hidden;
    animation: ${HeightAni} 0.3s cubic-bezier(.15,.88,.83,.67) forwards;
  }
  .hide {
    display: none;
  }
  .betslip-top-wrap--info, .money-wrap {
    transform: translateY(-12px);
  }
  // 폴드 및 배당 숫자 변경시 애니메이션
  .betslip-ani {
    &.fold {
      &.change-odds, &.change-even {
        ${CommonPeekAni};
      }
    }
  }
  // 베팅 슬립(bottom) 최소화
  .simple-betslip-top {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 47px;
    height: 47px;
    border: 1px solid #272D38;
    background: linear-gradient(310deg, #2B323E, #1C202B 80%);
    border-radius: 50%;
    .line {
      width: 10px;
      height: 1px;
      margin: 4px 0 3px;
      background: linear-gradient(310deg, #eee, #676C75);
    }
    .fold-num {
      line-height: 1.2rem;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.underover};
      &.zero {
        font-size: ${props => props.theme.font.title};
        color: ${props => props.theme.color.disableTxt};
      }
    }
    .rate {
      ${TxtLimit};
      display: inline-block;
      width: 37px;
      text-align: center;
      line-height: 1.2rem;
      font-size: ${props => props.theme.font.small};
      color: ${props => props.theme.color.themeTxt};
    }
    .betslip-simple-rate {
      display:flex;
      align-items: center;
      margin-left: 20px;
      .betslip-top-wrap--info--txt {
        margin-right: 7px;
      }
      .tooltip-btn {
        height: 28px;
        margin-right: -23px;
        svg {
          transform: translateX(-4px);
        }
      }
    }
    .betslip-simple-num {
      display: flex;
      align-items: center;
      min-width: 45px;
      height: 28px;
      border-radius: 50px;
      text-align: center;
      .ani-num {
        display: inline-block;
        margin: 0 auto;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
      }
      &.fold {
        padding: 0 15px;
        justify-content: flex-start;
        background: ${props => props.theme.color.themeTxt};
        .betslip-top-wrap--info--txt {
          margin-left: 20px;
        }
        .betslip-top-wrap--info--num {
          margin-left: 10px;
        }
      }
      &.rate {
        padding: 0 12px;
        .ani-num {
          color: ${props => props.theme.color.yellow};
        }
        justify-content: flex-end;
        .betslip-top-wrap--info--txt {
          margin-right: 4px;
          &.original-code {
            margin-right: 10px;
          }
        }
        .betslip-top-wrap--info--num {
         margin-right: 20px;
        }
      }
    }
  }
  .betslip-top-wrap {
    position: relative;
    height: 40px;
    background-color: ${props => props.theme.color.modalSubBg};
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    &:not(&.detail) {
      animation: ${ShowAni} 0.3s;
    }
    &--info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      float: left;
      width: 50%;
      height: 28px;
      line-height: 1.4rem;
      &--txt {
        position:relative;
        color: ${props => props.theme.color.modalBg};
      }
      &--num {
        display: flex;
        align-items: center;
        width: 50%;
        height: inherit;
        background: ${props => props.theme.color.modalSubBg2};
        border-radius: 50px;
        text-align: center;
        .ani-num {
          display: inline-block;
          margin: 0 auto;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.large};
        }
      }
    }
  }
  // 베팅 슬립(bottom) - 펼침
  .betslip-detail {
    &.test {
      position: fixed;
      bottom: 0;
      left: 0;
    }
    width: 100%;
    height: auto;
    .club-list-wrap {
      position: absolute;
      top: -30px;
      right: 0;
      width: auto;
      height: 30px;
      .icon {
        width: auto;
        height: 100%;
        object-fit: contain;
      }
    }
    .toggle-betslip-btn {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 42px;
      height: 42px;
      background: ${props => props.theme.color.modalBg};
      border-radius: 0;
      .cls-ico {
        position:relative;
        display: block;
        width: 14px;
        height: 14px;
        transform: rotate(-45deg) translate(2px, -2px);
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          bottom: 0;
          left: 0;
          background: ${props => props.theme.color.modalDarkBg};
        }
        &::before {
          width: 12px;
          height: 2px;
        }
        &::after {
          width: 2px;
          height: 12px;
        }
      }
    }
    .betslip-top-wrap {
      &--info {
        flex-wrap: wrap;
        &--txt {
          width: 100%;
          color: ${props => props.theme.color.modalSubTxt};
          font-size: ${props => props.theme.font.small};
          text-align: center;
        }
        &--num {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 14px;
          line-height: 1.4rem;
          color: ${props => props.theme.color.modalTxt};
          background: none;
          .gmoney-ico {
             ${GmoneyIcoStyle};
          }
        }
      }
    }
    .betslip-contents {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      padding: 10px 20px;
      background: ${props => props.theme.color.modalBg};
      .num-button-wrap {
        flex: 3;
        min-width: 200px;
      }
      &--detail-info {
        flex: 2;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-left: 12px;
        line-height: 1.2rem;
        &--wrap {
          display: flex;
          justify-content: space-between;
          align-items: center;
          &--txt {
            position:relative;
            color: ${props => props.theme.color.modalSubTxt};
          }
          &--num {
            flex:1;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 28px;
            margin-left: 11px;
            color: ${props => props.theme.color.modalTxt};
            background: ${props => props.theme.color.modalSubBg2};
            border-radius: 50px;
            span {
              color: ${props => props.theme.color.modalTxt};
            }
            &.rate {
              .ani-num {
                color: ${props => props.theme.color.modalOrange};
              }
            }
            .gmoney-ico {
              ${GmoneyIcoStyle};
              width: 14px;
            }
          }
          &--btn {
            margin-left: 4px;
          }
          // 배당
          &.dividend-rate {
            margin: 4px 0 7px;
            .betslip-contents--detail-info--wrap--txt {
              margin-right: 4px;
              &.original-code {
                margin-right: 0;
              }
            }
          }
          // 예상 적중금액
          &.dividend-money {
            flex-wrap: wrap;
            .betslip-contents--detail-info--wrap--txt {
              width: 100%;
            }
            .betslip-contents--detail-info--wrap--num {
              justify-content: flex-end;
              height: 18px;
              background: none;
            }
          }
        }
      }
    }
  }
  .simple-wrap {
    position: relative;
    top: -4px;
  }
  // 베팅 공유 베팅 슬립
  &.component-bet-slip {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0;
    transition: all 0.3s ease 0s;
    box-shadow: rgb(0 0 0 / 50%) 0 2px 5px;
    &.pc {
      position: relative;
    }
  }
`
// 금액 버튼 및 input
export const NumButtonWrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  line-height: 1.2rem;
  .money-input-wrap {
    position: relative;
    display: inline-block;
    width: 67%;
    input {
      width: calc(100% - 2px);
      border-radius: 50px;
      background-color: ${props => props.theme.color.modalSubBg2};
      border: 1px solid ${props => props.theme.color.modalDarkBg};
      height: 28px;
      color: ${props => props.theme.color.modalTxt};
      padding-right: 23px;
      text-align: right;
      line-height: 2.8rem;
    }
    &.expected {
      width: calc(100% - 20px);
      float: right;
      color: ${props => props.theme.color.modalTxt};
      text-align: right;
      line-height: 1.4rem;
    }
    &.betting-money {
      .bet-tag {
        width: 50px;
        line-height: 2.8rem;
      }
    }
    /* 베팅권 모달 */
    &.bet-coubpon-input-wrap {
      width: 100%;
      float: right;
      margin-bottom: 20px;
      input {
        height: 32px;
        line-height: 3.2rem;
        padding-right: 36px;
        font-size: ${props => props.theme.font.large};
      }
      &::after {
        content: '';
        display: block;
        clear: both;
      }
      .txt {
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translate(0, -50%);
        color: ${props => props.theme.color.modalSubTxt};
      }
      .bet-coupon-img {
        position: absolute;
        top: 50%;
        right: 8px;
        width: 26px;
        transform: translate(0, -50%);
      }
    }
    .gmoney-ico {
      ${GmoneyIcoStyle};
      position: absolute;
      top: 50%;
      right: 8px;
      transform: translate(0,-50%);
      width: 14px;
    }
  }

  /* 베팅 슬립 상세 */
  &.sider {
    padding: 12px 15px 0;
  }
`
export const NumButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc((100% / 3) - 3px);
  height: 30px;
  line-height: 3rem;
  margin-bottom: 5px;
  padding: 0;
  background: ${props => props.theme.color.secondaryBg};
  border: none;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  border-radius: 50px;
  &.other {
    background-color: ${props => props.theme.color.modalBlue};
  }
  &:not(.other) {
    .gmoney {
      float: none;
      top: 1px;
      margin-left: 2px;
    }
  }
  /* 베팅 목록 */
  &.sider-num-btn {
    justify-content: center;
  }
  .money-btn-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 60px;
    /* 베팅 목록 금액 g아이콘 */
    svg {
      width: 10px;
      margin-left: 2px;
    }
  }
`
export const Txt = styled.span`
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.color.modalSubTxt};
  &.top-txt {
    font-size: ${props => props.theme.font.medium};
  }
  &:not(.top-txt) {
    float: left;
  }
`
export const CommonGmoneyStyle = css`
  position: relative;
  float: right;
  width: 10px;
`
const BetCouponWidth = css`
  width: 27px;
`
export const SiderBetting = (theme: Theme) => css`
  width: 100%;
  height: 36px;
  border-radius: 0;
  &.disabled {
    color: ${theme.color.disableTxt};
    background: ${theme.color.disableBg};
    svg path {
      fill: ${theme.color.disableTxt};
    }
  }
`
export const BettingCouponStyle = (theme: Theme) => css`
  background-color: ${theme.color.modalBlue};
  width: calc(33% - 2px);
  height: 28px;
  border-radius: 50px;
  border: none;
  float: right;
  /* 베팅권 버튼 */
  img {
    z-index: -1;
    position: absolute;
    ${BetCouponWidth};
    top: -2px;
    left: 50%;
    transform: rotate(-15deg) translate(-120%, -40%);
  }
`
export const TrashStyle = styled.span`
  width: 10px;
`
export const ResetBtnStyle = (theme: Theme) => css`
  float: right;
  width: 28px;
  height: 28px;
  background-color: ${theme.color.btn};
  border-radius: 50px;
`
export const BettingBtnStyle = (theme: Theme) => css`
  width: 60%;
  height: inherit;
  line-height: 3.6rem;
  border-radius: 0;
  color: ${theme.color.themeTxt};
  background-color: ${theme.color.secondaryBg};
  &.disabled {
    color: ${theme.color.disableTxt};
    background: ${theme.color.disableBg};
    svg path {
      fill: ${theme.color.disableTxt};
    }
  }
`
export const ListBtnStyle = (theme: Theme) => css`
  width: 40%;
  height: inherit;
  line-height: 3.6rem;
  border-radius: 0;
  color: ${theme.color.themeTxt};
  background: ${theme.color.primaryBg};
  &.disabled {
    color: ${theme.color.disableTxt};
    background: ${theme.color.disableBg};
  }
  svg {
    top: 2px;
    width: 12px;
  }
`
// /////////////////////////////////////////// BetSlipSider /////////////////////////////////////////////
export const BetSlipSiderWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${props => props.theme.color.modalBg};
  * {
    font-size: ${props => props.theme.font.medium};
  }
  // 폴드 및 배당 숫자 변경시 애니메이션
  .betslip-ani {
    &.fold {
      &.change-odds, &.change-even {
        ${CommonPeekAni};
      }
    }
  }
`
export const BetSlipHeader = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 44px;
  padding: 0;
  overflow: hidden;
  border-bottom: 1px solid ${props => props.theme.color.gray};
  line-height: 4.4rem;
  text-align: left;
`
export const BottomContent = styled.div`
  z-index: 1; /* form태그 보다 앞으로 나와야함 */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  &.pc {
    position: relative;
    margin-top: -1px; /* 리스트의 구분선과 겹쳐지도록 */
    .gmoney-ico {
      top: -1px;
    }
  }
`
// 체크 박스 공통 스타일
const CommonCheckStyle = css`
  position: absolute;
  display: block;
  float: left;
  width: 20px;
  max-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: none;
  border-radius: 50%;
  transition: all 0.3s;
`
const CommonCheckAfterStyle = css`
  display: block;
  float: left;
  width: 20px;
  height: 20px;
  border: none;
`
export const CheckBoxWrapper = (theme: Theme) =>
  css`
    position: relative;
    top:11px;
    input {
      position: absolute;
      left: 0;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      border: 0;
      clip: rect(0, 0, 0, 0);
    }
    span {
      position: relative;
    }
    span::before {
      ${CommonCheckStyle};
      left: 16px;
      border: 3px solid ${theme.color.disableTxt};
      content: ' ';
    }
    input + span::after {
      display: block;
      clear: both;
      content: ' ';
    }
    input + span:active::before,
    input:checked + span:active::before {
      box-shadow: 0.01px 1px 2px ${theme.color.primaryBg}, inset 0.01px 1px 3px ${theme.color.primaryBg};
    }
    input:checked + span::before {
      ${CommonCheckAfterStyle};
      background: ${theme.color.primary};
      content: '';
    }
    input:checked + span img {
      opacity: 1;
    }
    .check-box-bg {
      position: relative;
      & img {
        left: 19px;
      }
    }
  `
export const Checkbox = (theme: Theme) =>
  css`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    border: 0;
    clip: rect(0, 0, 0, 0);
    & + label {
      position: absolute;
      left: 16px;
    }
    & + label::before {
      ${CommonCheckStyle};
      border: 3px solid ${theme.color.disableTxt};
      content: '';
    }
    &:checked + label::before {
      ${CommonCheckAfterStyle};
      background: ${theme.color.primary};
      content: '';
    }
    &:checked + label img {
      opacity: 1;
    }
  `
export const CheckboxImg = css`
  position: absolute;
  width: 14px;
  opacity: 0;
  left: 3px;
  top: 4px;
  transition: all 0.35s;
`
export const DeleteBtnStyle = (theme: Theme) =>
  css`
    z-index:1;
    position: absolute;
    top: 10px;
    left: 44px;
    width: 62px;
    height: 22px;
    line-height: 2.2rem;
    p {
      font-size: ${theme.font.small};
    }
  `
export const CloseBtn = (theme: Theme) =>
  css`
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: ${theme.color.TP};
    border: none;
    box-shadow: none;
    &::before {
      position: absolute;
      top: 16.5px;
      left: 15px;
      display: block;
      width: 20px;
      height: 20px;
      background: ${theme.color.TP};
      border: none;
      border-left: 2px solid ${theme.color.themeTxt};
      border-radius: 0;
      transform: rotate(45deg);
      opacity: 1;
      animation: none;
      content: '';
    }
    &::after {
      position: absolute;
      top: 3.5px;
      right: 5px;
      display: block;
      width: 20px;
      height: 20px;
      background: ${theme.color.TP};
      border-left: 2px solid ${theme.color.themeTxt};
      transform: rotate(-45deg);
      opacity: 1;
      content: '';
    }
  `
export const CloseBtnTxt = css({
  position: 'absolute',
  lineHeight: '9999',
})
export const FormStyle = (theme: Theme) => css`
  position: relative;
  width: 100%;
  height: calc(100vh - 353px);
  margin-top: -6px;
  padding-bottom: 80px; /* 아이폰에서 도구막대와 주소창으로 인해 높이가 줄어들면서 마켓 잘리는 현상 해결 */
  background: ${theme.color.modalSubBg2};
  overflow-x: hidden;
  overflow-y: scroll;
  &.pc {
    height: auto;
    min-height: 150px;
    max-height: 270px;
    margin-top: 0;
    padding-bottom: 0;
  }
`
export const BetSlipBody = styled.div`
  z-index: 10;
  bottom: 0;
  width: 100%;
  height: 272px;
  background: ${props => props.theme.color.modalBg};
  .hide {
    display: none;
  }
 .gmoney-ico {
    ${GmoneyIcoStyle};
    width: 14px;
  }
  .betslip-top-wrap {
    position: relative;
    margin-top: 12px;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    &--info {
      display: flex;
      align-items: center;
      float: left;
      width: 50%;
      height: 28px;
      &--txt {
        position:relative;
        min-width: 25px;
        color: ${props => props.theme.color.modalSubTxt};
      }
      &--num {
        display: flex;
        align-items: center;
        width: 70%;
        height: inherit;
        background: ${props => props.theme.color.modalSubBg2};
        border-radius: 50px;
        text-align: center;
        .ani-num {
          display: inline-block;
          margin: 0 auto;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.large};
        }
      }
      &.fold {
        padding-right: 9px;
        justify-content: flex-start;
        .betslip-top-wrap--info--txt {
          margin-left: 15px;
        }
        .betslip-top-wrap--info--num {
          margin-left: 10px;
        }
      }
      &.rate {
        padding-left: 9px;
        justify-content: flex-end;
        .ani-num {
          color: ${props => props.theme.color.modalOrange};
        }
        .betslip-top-wrap--info--txt {
          margin-right: 4px;
          &.origianl-code {
            margin-right: 10px;
          }
        }
        .betslip-top-wrap--info--num {
         margin-right: 15px;
        }
      }
    }
  }
  .money-wrap {
    display: flex;
    flex-wrap: wrap;
    padding: 4px 0;
    border: 1px solid ${props => props.theme.color.gray};
    border-left:none;
    border-right:none;
  }
  .money-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 28px;
    padding: 0 15px;
    .right-txt {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
    }
    &.dividend-money {
      height: 44px;
      margin-top: 12px;
      border-top: 1px solid ${props => props.theme.color.gray};
    }
  }
`
export const TxtColor = (theme: Theme) => css`
  color: ${theme.color.modalSubTxt};
  padding-right: 10px;
  &.bottom-txt {
    display: inline-block;
    margin-top: 5px;
  }
`
export const NumWrap = styled.span`
  position: relative;
  right: 4px;
  float: right;
  height: 24px;
  padding: 4px 8px;
  background: ${props => props.theme.color.disableTxt};
  border-radius: 50px;
`
// /////////////////////////////////////////// BetSlipHelper /////////////////////////////////////////////
const CommonHelperStyle = css`
  height: 60px;
`

export const BetSlipHelperList = styled.div`
  ${CommonHelperStyle};
  z-index: 1;
  position: relative;
  padding: 6px 0 4px 42px;

  border: 1px solid pink;
  &::after {
    z-index: 1;
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.color.gray};
  }
  &::before {
    z-index: -1;
    content: '';
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    animation: ${ShowAni} 1s 6 alternate forwards;
  }
  &.up {
    &::before {
      display: block;
      background: #af1c39;
    }
    .rate {
      /* color: ${props => props.theme.color.red}; */
    }
  }
  &.down {
    &::before {
      display: block;
      background: #1c55af;
    }
    .rate {
      /* color: ${props => props.theme.color.blue}; */
    }
  }
`
export const LabelWrap = styled.div`
  position: relative;
  top: 2px;
  text-align: left;
`
export const SlipWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 15px;
  line-height: 1.5rem;
  padding-right: 16px;
`
export const PickTxt = styled.span`
  color: ${props => props.theme.color.modalTxt};
  font-size: ${props => props.theme.font.small};
`
export const Rate = styled.span`
  float: right;
  color: ${props => props.theme.color.modalyellow};
  font-size: ${props => props.theme.font.small};
`
export const TypeTxt = styled.span`
  float: right;
  color: ${props => props.theme.color.modalTxt};
  font-size: ${props => props.theme.font.small};
`
export const BetPoint = styled.span`
  color: ${props => props.theme.color.modalBlue};
  font-size: ${props => props.theme.font.small};
`
export const TeamWrap = styled.div`
  float:left;
  width: 100%;
  height: 15px;
  line-height: 1.5rem;
  color: ${props => props.theme.color.modalTxt};
  font-size: ${props => props.theme.font.small};
  .vs {
    width: auto;
    margin: 0 4px;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.small};
  }
`
export const HelperCheckboxStyle = css`
  position: relative;
  &::before {
    top: 14px;
  }
  .helper-check-box {
    position: absolute;
    left: 0;
  }
`
export const HelperCheckBoxImgStyle = css`
  top: 18px;
`
export const Fold = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  float: right;
  width: 100px;
  margin-right: 20px;
  // 폴드 숫자 변경시 애니메이션
  .betslip-ani {
    &.fold {
      &.change-odds, &.change-even {
        ${CommonPeekAni};
      }
    }
  }
  .txt {
    color: ${props => props.theme.color.modalSubTxt};
  }
  .num {
    z-index: 1;
    position: relative;
    display: inline-block;
    width: 55px;
    height: 22px;
    line-height: 2.2rem;
    margin-left: 10px;
    text-align: center;
    border-radius: 50px;
    background: ${props => props.theme.color.modalSubBg2};
    .ani-num {
      display: inline-block;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
    }
  }
  &.bet-sider-fold {
    position: relative;
    line-height: 0;
    text-align: right;
    top: 11px;
  }
`
export const ContinueBtn = (theme: Theme) => css`
  float: right;
  width: 70px;
  height: 43px;
  padding: 0 8px;
  border-radius: 0;
  transition: all 0.3s;
  background: ${theme.color.modalBlue};
  .btn-txt {
    position: relative;
    left: -6px;
    width: 22px;
    height: 32px;
    line-height: 1.4rem;
  }
  svg {
    position: absolute;
    top: 18px;
    right: 5px;
    width: 14px;
    transform: rotate(-90deg);
  }
  &.hide {
    display: none;
  }
`
export const BetSlipPenaltyWrap = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
  text-align: center;
  padding: 5px 0;
  .penalty-info {
    color: ${props=>props.theme.color.modalSubTxt};
    .blue-point {
      color: ${props=>props.theme.color.secondaryBg};
    }
  }
  .penalty-sub-info {
    font-weight: ${props=>props.theme.fontW.medium};
    color: ${props=>props.theme.color.modalSubTxt};
  }
`
//
export const BetSlipPopover = css`
  position: fixed;

`
export const BetSlipListWrap = styled.div`
  display: flex;
  flex-flow: column;
  max-height: calc(80vh + 45px);
  flex: 1;
  background: ${props=>props.theme.color.modalBg};
  &.android-betslip {
    .am-tabs-pane-wrap-inactive {
      visibility: hidden;
    }
  }
  &.ios-betslip {
    .am-tabs-pane-wrap {
      opacity: 0.99;
    }
  }
  .bet-header {
    z-index: 1;
    position: absolute;
    top: 43px;
    left: 0;
    width: 100%;
    height: 42px;
    line-height: 4.2rem;
    padding-left: 14px;
    background: ${props=>props.theme.color.themeTxt};
    text-align: left;
    .fold {
      padding-right: 10px;
      color: ${props=>props.theme.color.modalTxt};
      font-weight: ${props=>props.theme.fontW.medium};
      border-right: 1px solid ${props=>props.theme.color.modalDarkBg};
      &.no-line {
        border: none;
      }
      .fold-num {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        margin-right: 6px;
        color: ${props=>props.theme.color.themeTxt};
        border-radius: 50%;
        background: ${props=>props.theme.color.modalTxt};
      }
    }
    .keep-bet {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 10px;
      color: black;
      font-weight: ${props=>props.theme.fontW.medium};
    }
    .delete-all {
      position: relative;
      float: right;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90px;
      height: 42px;
      color: ${props=>props.theme.color.modalTxt};
      font-weight: ${props=>props.theme.fontW.medium};
      text-align: center;
      background: none;
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: 12px;
        left: 50%;
        transform: translateX(-31%);
        width: 50%;
        height: 1px;
        background: ${props=>props.theme.color.modalTxt};
      }
      .x-ico {
        position: relative;
        display: block;
        width: 14px;
        height: 14px;
        margin-right: 4px;
        background: ${props=>props.theme.color.modalTxt};
        border-radius: 50%;
        &::before, &::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 7px;
          height: 1px;
          background: ${props=>props.theme.color.themeTxt};
        }
        &::before {
          transform: translate(-50%, -50%) rotate(45deg);
        }
        &::after {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
    }
  }
  .bet-list {
    flex: 1;
    height: auto;
    max-height: calc(100% - 200px);
    margin: 6px 0;
    padding: 0 6px;
    overflow: auto;
    background: ${props=>props.theme.color.modalBg};
    &.short {
      max-height: calc(100% - 268px);
    }
  }
  svg {
    width: 12px;
  }
  .bet-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 14px;
    background: ${props=>props.theme.color.themeTxt};
    .additional-dividend {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 12px;
      padding: 9px 12px 9px 9px;
      background: ${props=>props.theme.color.modalBg};
      .select-btn {
        z-index: 0;
        width: 38px;
        height: 38px;
        border-radius: 3px;
        background: ${props=>props.theme.color.themeTxt};
        .selected-img {
          width: auto;
          height: inherit;
        }
      }
      .selected-info {
        flex: 1;
        line-height: 1.6rem;
        padding-left: 9px;
        text-align: left;
        .selected-card {
          position: relative;
          display: inline-block;
          margin-top: -8px;
          margin-bottom: -10px;
          color: ${props=>props.theme.color.modalTxt};
          button {
            z-index: 0;
            left: -7px;
            top: -1px;
            width: 36px;
            height: 36px;
            img {
              width: 14px;
              height: auto;
            }
          }
          .pc-clear-btn {
            position: absolute;
            top: -32px;
            left: -29px;
            transition: all .3s;
            &:hover {
              opacity: .5;
            }
          }
        }
      }
      .dividend-value {
        color: ${props=>props.theme.color.modalTxt};
        font-size: ${props=>props.theme.font.title};
      }
    }


    .bet-detail-info {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 50%;
        height: 18px;
        margin-bottom: 6px;
        &:nth-of-type(n) {
          padding: 0 8px 0 4px;
        }
        &:nth-of-type(2n) {
          padding: 0 0 0 6px;
        }
        .detail-txt {
          color: ${props=>props.theme.color.modalSubTxt};
          font-weight: ${props=>props.theme.fontW.medium};
        }
        .detail-num {
          display: inline-flex;
          align-items: center;
          justify-content: flex-end;
          color: ${props=>props.theme.color.modalTxt};
          svg {
            margin-left: 5px;
          }
          &.point {
            color: ${props=>props.theme.color.modalOrange};
          }
          .txt {
            margin-left: 5px;
            color: ${props=>props.theme.color.modalSubTxt};
            font-weight: ${props=>props.theme.fontW.medium};
          }
          &.total {
            position: relative;
            justify-content: flex-end;
            width: auto;
            //min-width: 66px;
            height: 24px;
            padding: 0 8px;
            font-size: ${props=>props.theme.font.title};
            //background: ${props=>props.theme.color.modalBg};
            border-radius: 3px;
            &::before {
              content: '';
              display: block;
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 80%;
              height: 10px;
              background: ${props => props.theme.color.modalyellow};
              opacity: .2;
            }
          }
        }
        .penalty-info-btn {
          z-index: 0;
          display: flex;
          align-items: center;
          width: auto;
          height: auto;
          background: none;
          svg {
            width: 14px;
            height: auto;
            margin-right: 4px;
            margin-left: 0;
          }
        }
      }
    }
    // 금액 입력란
    .bet-input {
      //position: relative;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: calc(50% - 3px);
      height: 32px;
      color: ${props=>props.theme.color.modalTxt};
      font-size: ${props=>props.theme.font.large};
      padding-right: 12px;
      border-radius: 3px;
      border: 1px solid ${props=>props.theme.color.modalSubBg};
      background: ${props=>props.theme.color.themeTxt};
      input {
        width: 100%;
        height: 32px;
        line-height: 3.2rem;
        padding-right: 0;
        text-align: right;
        color: ${props=>props.theme.color.modalTxt};
        font-size: ${props=>props.theme.font.large};
        border: none;
        background: none;
      }
      svg {
        min-width: 12px;
        margin-left: 4px;
        transform: translateY(-1px);
      }
    }

    // 금액 버튼
    .bet-btn {
      z-index: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: calc(25% - 3px);
      height: 32px;
      border-radius: 3px;
      svg {
        margin-left: 4px;
      }
      img {
        width: 25px;
      }
      &.bet-coupon {
        justify-content: space-between;
        padding: 0 12px;
        & > span {
          display: flex;
        }
        .coupon-value {
          position: relative;
          transform: rotate(45deg);
          width: 6px;
          margin-right: 4px;
          &::before, &::after {
            content: '';
            display: block;
            position:absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: ${props=>props.theme.color.themeTxt};
            border-radius: 10px;
          }
          &::before {
            width: 8px;
            height: 1px;
          }
          &::after {
            width: 1px;
            height: 8px;
          }
        }
      }
      &:not(.other) {
        margin-top: 4px;
      }
      &.other {
        background: ${props=>props.theme.color.modalBlue};
      }
    }
  }

  .ongoing-bet-btn, .do-bet-btn  {
    z-index: 0;
    width: calc(50% - 2px);
    height: 40px;
    margin-top: 10px;
    border-radius: 3px;

  }
  .ongoing-bet-btn.component-bet-slip, .do-bet-btn.component-bet-slip {
    z-index: 2;
  }
  .ongoing-bet-btn {
    background: ${props=>props.theme.color.primaryBg};
    .am-badge {
      z-index: 0;
      position:relative;
      top: -1px;
      right: 0;
      left: 10px;
      .am-badge-text {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: ${props=>props.theme.font.large};
      }
    }
    .plus-ani {
      opacity: 0;
      position: absolute;
      top: 3px;
      right: 18%;
      color: ${props=>props.theme.color.modalTxt};
      font-size: ${props=>props.theme.font.large};
      animation: ${betslipPlusAni} .6s 1 forwards cubic-bezier(0,.48,.82,1);
      animation-delay: .1s;
    }
  }
  .do-bet-btn {
    .default {
      width: 20px;
      height: 20px;
      transform: translateY(4px);
      &::after, &--bar {
        border-top-color: ${props=>props.theme.color.themeTxt};
      }
    }
    &.refresh-btn {
      background: ${props=>props.theme.color.modalyellow};
    }
  }
`
const upChangeBgAni = keyframes`
  34%, 69% {
    background: rgba(220, 35, 35, 0.01);
    border: 1.5px solid rgba(220, 35, 35, 0.2);
  }
  0%, 10%, 45%, 85% {
    background: rgba(220, 35, 35, 0.04);
    border: 1.5px solid rgba(220, 35, 35, 0.7);
  }
  100% {
    background: rgba(220, 35, 35, 0);
    border: 1.5px solid rgba(220, 35, 35, 0);
  }
`
const downChangeBgAni = keyframes`
  34%, 69% {
    background: rgba(23, 93, 165, 0.01);
    border: 1.5px solid rgba(23, 93, 165, 0.2);
  }
  0%, 10%, 45%, 85% {
    background: rgba(23, 93, 165, 0.04);
    border: 1.5px solid rgba(23, 93, 165, 0.7);
  }
  100% {
    background: rgba(23, 93, 165, 0);
    border: 1.5px solid rgba(23, 93, 165, 0);
  }
`
const upChangeAni = keyframes`
  0%, 10%, 20%, 35%, 45%, 55%, 70%, 80%, 90% {
    opacity: 1;
    transform: translateY(0%);
  }
  5%, 15%, 40%, 50%, 75%, 85% {
    transform: translateY(-10%);
  }
  100% {
    opacity: 0;
  }
`
const downChangeAni = keyframes`
  0%, 10%, 20%, 35%, 45%, 55%, 70%, 80%, 90%  {
    opacity: 1;
    transform: rotate(180deg) translateY(-25%);
  }
  5%, 15%, 40%, 50%, 75%, 85% {
    transform: rotate(180deg) translateY(-35%);
  }
  100% {
    opacity: 0;
  }
`
export const BetSlipHelperListWrap = styled.li`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.color.themeTxt};
  border-radius: 10px;
  overflow: hidden;
  &:not(:first-of-type) {
    margin-top: 6px;
  }
  .bet-list-info {
    position: relative;
    height: 100%;
    padding: 15px 16px 14px 13px;
    border-radius: 10px;
    &::before {
      content:'';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
    .select-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
      .live-tag-icon {
        width: auto;
        height: 14px;
        margin-right: 3px;
      }
      .select-team, .rate {
        line-height: 2.4rem;
        color: ${props=>props.theme.color.modalTxt};
        font-size: ${props=>props.theme.font.title};
      }
      .select-team {
        ${TxtLimit};
        margin-right: auto;
      }
      .rate {
        min-width: 63px;
        margin-left: 17px;
        text-align: right;
        // 배당 변화
        .change-rate-arrow {
          position: relative;
          display: inline-block;
          width: 10px;
          height: 14px;
          margin-right: 6px;
          transform: translateY(5%);
          &::before, &::after {
            content: '';
            display: block;
            position:absolute;
            left: 50%;
            transform: translateX(-50%);
          }
          &::before {
            top: 0;
            width: 10px;
            height: 7px;
            border-top: none;
            border-bottom: 5px solid transparent;
            border-right: 5px solid transparent;
            border-left: 5px solid  transparent;
          }
          &::after {
            top: 7px;
            width: 4px;
            height: 8px;
          }
        }
      }
    }
    .market-item {
      display: flex;
      margin-bottom: 6px;
      line-height: 1.8rem;
      .market-name {
        ${TxtLimit};
        color: ${props=>props.theme.color.btn};
        font-weight: ${props=>props.theme.fontW.medium};
      }
      .bet-point {
        color: ${props=>props.theme.color.secondaryBg};
      }
    }
    .team-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      .team-detail-info {
        ${TxtLimit};
        display: flex;
        align-items: center;
        .team-name {
          ${TxtLimit};
          line-height: 1.8rem;
          color: ${props=>props.theme.color.btn};
          font-weight: ${props=>props.theme.fontW.medium};
          margin-right: 30px;
        }
      }
    }
    // 배당 변경 연출
    &.up {
      &::before {
        animation: ${upChangeBgAni} 4.2s 1 forwards;
      }
      .select-info {
        .rate {
          .change-rate-arrow {
            animation: ${upChangeAni} 4.2s 1 forwards;
            &::before {
              border-bottom: 5px solid ${props=>props.theme.color.red};
            }
            &::after {
              background: ${props=>props.theme.color.red};
            }
          }
        }
      }
    }
    &.down {
      &::before {
        animation: ${downChangeBgAni} 4.2s 1 forwards;
      }
      .select-info {
        .rate {
          .change-rate-arrow {
            transform: rotate(180deg) translateY(-20%);
            animation: ${downChangeAni} 4.2s 1 forwards;
            &::before {
              border-bottom: 5px solid ${props=>props.theme.color.secondaryBg};
            }
            &::after {
              background: ${props=>props.theme.color.secondaryBg};
            }
          }
        }
      }
    }
  }
  .delete-select {
    position: absolute;
    bottom: 6px;
    right: 14px;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    margin: 2px;
    background: none;
    svg {
      width: 14px;
      path {
        fill: ${props=>props.theme.color.btn};
      }
    }
  }
  &.lock {
    .delete-select {
      background-color: ${props => props.theme.color.white} !important;
      z-index: 5 !important;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
    }
  }
  .lock-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 34px;
    height: 34px;
    z-index: 5;
  }
`
export const BetSlipGuideTxtWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 42px;
  .modal-bg {
    z-index: 2;
    opacity: .8;
  }
  img {
    z-index: 2;
    position: absolute;
    width: auto;
    &.dia-txt-guide {
      bottom: 46px;
      left: 78px;
      height: 75px;
    }
    &.slip-txt-guide {
      bottom: -55px;
      left: 74px;
      height: 95px;
    }
  }
`
export const DividendCardWrap = styled.div`
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .contents-wrap {
    display: flex;
    flex-flow: column;
    align-items: center;
    .switch {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      padding: 0 24px;
      text-align: right;
      .popover {
        display: inline-block;
      }
      .ant-switch {
        margin-left: 9px;
        background: ${props => props.theme.color.modalSubBg};
        &::after {
          transition-duration: 0.3s;
          transition-timing-function: ease;
        }
        .ant-switch-inner {
          min-width: 22px;
          text-transform: uppercase;
        }
        .ant-click-animating-node {
          box-shadow: none;
        }
        &.ant-switch-checked {
          background: ${props => props.theme.color.primaryBg};
        }
      }
    }
    .card-list {
      display: inline-flex;
      gap: 10px;
      width: auto;
      max-width: 100vw;
      margin: 13px 0 16px;
      padding: 14px;
      overflow-x: auto;
      white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
      .card-item {
        height: auto;
        padding: 0;
        background: none;
        border: none;
        box-shadow: none;
        &::before, &::after {
          display: none;
        }
        .ant-radio-button + span {
          position: relative;
          display: inline-block;
          min-width: 105px;
          min-height: 178px;
          border-radius: 4px;
          overflow: hidden;
          border: 2px solid ${props => props.theme.color.TP};
          img {
            width: auto;
            height: 178px;
          }
          &::after {
            content:'';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .4);
          }
          .card-quantity {
            position: absolute;
            bottom: 12px;
            left: 50%;
            transform: translateX(-50%);
            display: inline-block;
            height: 20px;
            line-height: 20px;
            padding: 0 10px;
            border-radius: 50px;
            color: ${props => props.theme.color.modalTxt};
            background: ${props => props.theme.color.themeTxt};
          }
        }
        .ant-radio-button-checked + span {
          border-color: ${props => props.theme.color.underover};
          box-shadow: 0 0 8px #fff;
        }
      }
      &.selected {
        .card-item.ant-radio-button-wrapper-checked {
          .ant-radio-button + span {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }
`
export const BetSlipClubIconPcStyle  = (theme: Theme) => css`
  z-index: 1;
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  right: 15px;
`
